<div class="e-selector-dropdown-container">
    <div class="e-left-col">
        <div class="e-selector-content">
            <h2 class="e-section-heading">DATE</h2>
            <div class="e-date-picker">
                <mat-form-field>
                    <mat-label>Choose a date</mat-label>
                    <input matInput [matDatepicker]="picker" [value]="selectedDate()"
                        (dateChange)="onDateChange($event)" #dateInput placeholder="DD/MM/YYYY">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                @if (invalidDate()) {
                <div class="form-error">
                    <span>Please enter a valid date</span>
                </div>
                }
            </div>
        </div>
    </div>
    <div class="e-right-col">
        <h2 class="e-selections-heading">YOUR SELECTIONS</h2>
        <button class="e-clear-all" attr.aria-label="Clear all selections" [disabled]="!selectedDate()"
            (click)="onClearAll()">
            Clear All
        </button>
        <div class="e-selections">
            <p *ngIf="!selectedDate()" class="e-no-selections">No selections have been made</p>
            <div class="e-selected-list" *ngIf="selectedDate()">
                <div class="e-selected-item">
                    <span class="e-selection-name" title="{{ selectedDate() | date:'dd/MM/yyyy' }}">
                        {{ selectedDate() | date:'dd/MM/yyyy' }}
                    </span>
                    <button class="e-clear-item" attr.aria-label="Remove date from selection"
                        (click)="onRemoveSelection()">
                    </button>
                </div>
            </div>
        </div>
        <div class="e-button-group">
            <button class="e-button"  (click)="onConfirmSelection()">OK</button>
            <button class="e-button" (click)="onCancel()">CANCEL</button>
        </div>
    </div>
</div>